import React from 'react';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import PasswordResetOverride from 'Overrides/Authentication/PasswordReset';
import classNames from 'classnames';
import PasswordResetEmailFormLayout from './Layouts/PasswordResetEmailFormLayout';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(0, 2),
  },
  form: {
    padding: 0,
  },
});

const PasswordResetEmailForm = ({
  className,
  classes,
  authCollection,
}) => {
  return (
    <MetaCollectionFormInline
      classes={{
        root: classNames(className, classes.root),
        form: classes.form,
      }}
      collection={authCollection}
      metaOverrideSet={PasswordResetOverride}
      FormProps={{
        layout: PasswordResetEmailFormLayout,
        LayoutProps: {
          onlyUnsourcedErrors: true,
          showRemainingFieldList: false,
          hideErrorList: true,
        },
        readonly: true, // <--- Hides default Submit button
      }}
    />
  );
};

PasswordResetEmailForm.defaultProps = {
  className: '',
};

PasswordResetEmailForm.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  authCollection: PropTypes.object.isRequired,
};

export default withStyles(styles)(PasswordResetEmailForm);
